import { gql } from "@stadium/services/apollo-client";

export const publishDummyStore = gql`
  mutation publish($input: PublishInput!) {
    publish(input: $input) {
      response {
        entity {
          ... on Store {
            id
            number
            name
          }
        }
        errors
      }
    }
  }
`;
